module.exports = __webpack_public_path__ + "static/media/logo-2023.a9cc788c.png";